import { InjectionToken } from '@angular/core';
import { AccredibleToastData } from './model/toast.model';

export const TOAST_DATA = new InjectionToken<AccredibleToastData>('TOAST_DATA');
